import { render, staticRenderFns } from "./DivisionShow.vue?vue&type=template&id=66a4767e&"
import script from "./DivisionShow.vue?vue&type=script&lang=js&"
export * from "./DivisionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports